import api from "./axios";
import { add_beneficiary } from "./beneficiary_api";
import { getBeneficiaryFromRequest } from '../utils/fetchFromUrl.js';

function handleApiError(err) {
  const customError = new Error('Server error. Please try again later.');
  customError.status = err.response ? err.response.status : 500;
  throw customError;
}

export const getAllDigitalRequestsApi = async () => {
  try {
    const response = await api.get('/digital-request');
    if (!response || !response.data) {
      throw new Error('No data received from server');
    }
    return response.data;
  } catch (err) { handleApiError(err); }
};

export const getDigitalRequestByIdApi = async (id) => {
  try {
    const response = await api.get(`/digital-request/${id}`);
    if (!response || !response.data) {
      throw new Error('No data received from server');
    }
    return response.data;
  } catch (err) { handleApiError(err); }
};

export const deleteDigitalRequestApi = async (id) => {
  try {
    const response = await api.delete(`/digital-request/delete/${id}`);
    if (![200, 201, 202, 204].includes(response.status)) {
      throw new Error('Unexpected response status: ' + response.status);
    }
    return response.data;
  } catch (err) { handleApiError(err); }
};

export const updateDigitalRequestApi = async (id, updatedData) => {
  try {
    const response = await api.put(`/digital-request/update/${id}`, updatedData);
    if (![200, 201, 202, 204].includes(response.status)) {
      throw new Error('Unexpected response status: ' + response.status);
    }
    return response.data;
  } catch (err) { handleApiError(err); }
};

export const submitDigitalFormApi = async (formData) => {
  try {
    const response = await api.post('/digital-request/add', formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    if (![200, 201, 202, 204].includes(response.status)) {
      throw new Error('Unexpected response status: ' + response.status);
    }
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getDigitalRequestJsonUrlApi = async (id) => {
  const response = await api.get(`/digital-request/json/${id}`);
  return response.data;
};